const config = {
  env: window._env_.ENV,
  apiURL: window._env_.API_URL,
  apiURL2: window._env_.FORMBUILDER_URL,
  documentURL: window._env_.DOCVAULT_URL,
  disabledDates: [
    //new Date(2025, 7, 6), 
    //new Date(2025, 7, 7),
  ],
  disabledTimes: [
    //"09:00", 
    //"13:00"
  ]

};
// const config = {
//   env: "uat",
//   apiURL: "https://aamergateway.azurewebsites.net",
//   apiURL2: "https://aamerformbuilder.azurewebsites.net",
//   documentURL: "https://aamerdocvault.azurewebsites.net"
// };

const CONFIG = config;

export default CONFIG;
